import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

/**
 * Aba "Gestão de fornecedores" da tela Operar Cliente (Área do Contador).
 *
 * Wrapper fino que reusa a tela COMPLETA de fornecedores (`app-fornecedores`) em
 * modo EMBUTIDO, sob o contexto do cliente (`X-Empresa-Contexto` injetado pelo
 * interceptor). O contador consulta, ADICIONA e EDITA os fornecedores do seu
 * cliente. Excluir e ações que saem do contexto ficam de fora.
 *
 * Re-montado ao ABRIR a aba e ao TROCAR de cliente, para refletir sempre o
 * cliente vigente (a lista é carregada no `ngOnInit` da tela reusada).
 */
@Component({
  selector: 'app-operar-fornecedores',
  templateUrl: './operar-fornecedores.component.html',
  styleUrls: ['./operar-fornecedores.component.scss'],
})
export class OperarFornecedoresComponent implements OnChanges {
  /** Id da empresa do cliente — muda quando o contador troca de cliente. */
  @Input() clienteEmpresaId?: number | null;

  /** Indica se a aba está ativa; monta o componente pesado quando a aba abre. */
  @Input() ativo = false;

  /** Controla a existência do componente pesado (montagem sob demanda + re-mount). */
  montado = false;

  ngOnChanges(changes: SimpleChanges): void {
    const abriuAgora =
      !!changes['ativo'] && this.ativo && changes['ativo'].previousValue !== true;
    const trocouCliente =
      !!changes['clienteEmpresaId'] && !changes['clienteEmpresaId'].firstChange;

    if (changes['ativo'] && !this.ativo) {
      this.montado = false;
      return;
    }

    if (abriuAgora || (trocouCliente && this.ativo)) {
      if (this.montado) {
        this.montado = false;
        Promise.resolve().then(() => {
          this.montado = true;
        });
      } else {
        this.montado = true;
      }
    }
  }
}
